import React, { useContext, useRef, useState } from "react";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import config from "../../../config/config";
import axios from "axios";
import { ErrorMessage, Field, Form, Formik } from "formik";

import { uploadAWS } from "../../../common/AWSHelper";
import { Modal } from "react-bootstrap";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  AWS_IMAGE_FOLDER_RECEIVING,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";

import Select from "react-select";
import CommonDatePicker from "../../../components/DatePicker/CommonDatePicker";
import moment from "moment";
import { toastError, toastSuccess } from "../../../common/Toast";
import { Noimage } from "../../../common/imagePath";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import loadingimage from "../../../assets/img/loading-svg.svg";
import RecentTransactionsModal from "../../../components/Modal/RecentTransactionsModal";
import CommonPreviousInvoiceComponent from "../../../components/Account/CommonPreviousInvoiceComponent";
import QuickbookSyncMessageComponent from "../../../components/StoreConfig/QuickbookSyncMessageComponent";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";

const ExpenseNewLayout = (props) => {
  const paramObject = useParams();
  const MySwal = withReactContent(Swal);
  let navigate = useNavigate();
  const { CurrencySymbol, FractionDigits, QuickBookExpense, AllowQBSync } =
    useContext(AppContext);
  const token = localStorage.getItem("Token");
  const Id = localStorage.getItem("ID");
  const Location = localStorage.getItem("Location");
  const qtyInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [Data, SetData] = useState([]);
  const [ImageUrl, setImageUrl] = useState("");
  const [btnLoader, setBtnLoader] = useState({ Attachments: false });
  const [payeeoptions, setPayeeOptions] = useState([]);
  const [Account, setAccount] = useState([]);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedaccount, setSelectedAccount] = useState(0);
  const [prevSelectedaccount, setPrevSelectedAccount] = useState(0);
  const [selectedAccountName, setSelectedAccountName] = useState(0);
  const [selectedaccountbal, setselectedaccountbal] = useState(0);
  const [selectpayee, setselectpayee] = useState(0);
  const [AmountPaid, setAmountPaid] = useState(0);
  const [payeetypeid, setpayeetypeid] = useState(0);
  const [localValues, setLocalValues] = useState({});
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [paymentMethodId, setPaymentMethodId] = useState(0);
  const [prevPaymentMethodId, setPrevPaymentMethodId] = useState(0);
  const [referenceNumber, setReferenceNumber] = useState("");
  const [selectedtags, setSelectedtags] = useState([]);
  const [ExpenseTotal, setExpenseTotal] = useState(0);
  const [tag, setTag] = useState(0);
  // const [deleteIndex, setDeleteIndex] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [memo, setmemo] = useState("");
  const [isCC_Credit, setIsCC_Credit] = useState(0);
  const [show, setShow] = useState(false);
  const [tagsdropdwonData, setTagsdropdwonData] = useState([]);
  const [showtag, setShowTag] = useState(false);
  const [formValuesfortagmodel, setFormValuesforTagmodel] = useState({
    ID: 0,
    Tags: "",
  });
  const [ExpenseDate, setexpensedate] = useState(moment().format("YYYY-MM-DD"));
  const [toggled, setToggled] = useState(true);
  let updatedData = [];

  // Quickbook  Key
  const [Quickbookaccount, setquickbookaccount] = useState(0);
  const [QuickbookPayee, setQuickbookPayee] = useState(0);
  const [trnQuickbookid, settrnQuickbookid] = useState(0);
  const [paymentQB, setpaymentQB] = useState("");
  const [QBPaymentmethod, setQBPaymentmethod] = useState(0);
  const [isCheckSelected, setIsCheckSelected] = useState(0);
  const [printLater, setPrintLater] = useState(false);
  const [prevRefNum, setPrevRefNum] = useState("");
  console.log(selectpayee, payeetypeid, "payeetypeid check");

  //Helper function
  function calculateTotal(CostPrice, itemquantity, itemdiscount) {
    // const item = statenew[index];
    if (isNaN(CostPrice)) {
      CostPrice = 0;
    }
    if (isNaN(itemquantity)) {
      itemquantity = 0;
    }
    if (isNaN(itemdiscount)) {
      itemdiscount = 0;
    }
    const totalPrice = CostPrice * itemquantity * (1 - itemdiscount / 100);

    return totalPrice;
  }

  console.log(selectedaccount, "selectedaccount");
  console.log(QBPaymentmethod, "QBPaymentmethod check");

  const handleaccount = (e) => {
    setSelectedAccount(e.value);
    setquickbookaccount(e.QuickBookId);
    setselectedaccountbal(e.Amount);
    setSelectedAccountName(e.label);
    if (paramObject.id === undefined) {
      console.log(paramObject, "localstr");
      const localValue1 =
        JSON.parse(localStorage.getItem("ExpenseDraft")) || {};
      const x = {
        ...localValue1,
        Selectedaccount: e.value,
        selectedaccountbal: e.Amount,
        quickbookaccount: e.QuickBookId,
      };
      setLocalValues(x);
      localStorage.setItem("ExpenseDraft", JSON.stringify(x));
    }
  };

  const Handelmemo = (e) => {
    console.log(e.target.value, "ggfrer");

    setmemo(e.target.value);

    if (paramObject.id === undefined) {
      console.log(paramObject.id, "localstr");
      const localValue1 =
        JSON.parse(localStorage.getItem("ExpenseDraft")) || {};
      const x = {
        ...localValue1,
        memo: e.target.value,
      };
      setLocalValues(x);
      localStorage.setItem("ExpenseDraft", JSON.stringify(x));
    }
  };

  // Aws upload image
  const uploadFile = async (file, type) => {
    setBtnLoader({ [type]: true });
    setLoading(true);
    await uploadAWS(file, AWS_IMAGE_FOLDER_RECEIVING, (data) => {
      if (data) {
        if (type === "SelectImage") {
          console.log("data: ", data);
          setImageUrl(data);
          setLoading(false);
        }
      }
    });
  };

  const validation = (name, value) => {
    switch (name) {
      case "SelectImage":
        if (!value.name.match(/\.(jpg|jpeg|png|gif)$/)) {
          return false;
        } else {
          return true;
        }
      default: {
        return true;
      }
    }
  };
  const _handleFileChange = (e) => {
    console.log(e.currentTarget.files[0]);

    if (validation(e.target.name, e?.currentTarget?.files[0])) {
      console.log(1);
      uploadFile(e?.currentTarget?.files[0], e.target.name);
    }
  };

  const handlepayee = (e) => {
    if(paramObject.id !== undefined){
      MySwal.fire({
        title: "Are you sure?",
        text: "Are You Sure, You want Change",
        showCancelButton: true,
        confirmButtonColor: "#00ff00",
        confirmButtonText: "Yes!",
        cancelButtonColor: "#ff0000",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          setselectpayee(e.value);
          setpayeetypeid(
            e.Type == "Supplier"
              ? 0
              : e.Type == "Customer"
              ? 1
              : e.Type == "Employee"
              ? 2
              : 0
          );
          setQuickbookPayee(e.QuickBookId);
          // if (paramObject.id === undefined) {
          //   const localValue1 =
          //     JSON.parse(localStorage.getItem("ExpenseDraft")) || {};
          //   const x = {
          //     ...localValue1,
          //     payee: e.value,
          //     payeeqb: e.QuickBookId,
          //     payeetypeid:
          //       e.Type == "Supplier"
          //         ? 0
          //         : e.Type == "Customer"
          //         ? 1
          //         : e.Type == "Employee"
          //         ? 3
          //         : 0,
          //   };
          //   setLocalValues(x);
          //   localStorage.setItem("ExpenseDraft", JSON.stringify(x));
          // }
        } else {
          MySwal.close();
        }
      });
    }else{
        setselectpayee(e.value);
          setpayeetypeid(
            e.Type == "Supplier"
              ? 0
              : e.Type == "Customer"
              ? 1
              : e.Type == "Employee"
              ? 2
              : 0
          );
          setQuickbookPayee(e.QuickBookId);
          // if (paramObject.id === undefined) {
            const localValue1 =
              JSON.parse(localStorage.getItem("ExpenseDraft")) || {};
            const x = {
              ...localValue1,
              payee: e.value,
              payeeqb: e.QuickBookId,
              payeetypeid:
                e.Type == "Supplier"
                  ? 0
                  : e.Type == "Customer"
                  ? 1
                  : e.Type == "Employee"
                  ? 3
                  : 0,
            };
            setLocalValues(x);
            localStorage.setItem("ExpenseDraft", JSON.stringify(x));
    // }

  };
};
  const handleChangePaymet = (e) => {
    setPaymentMethodId(e.value);
    setpaymentQB(e.label);
    setQBPaymentmethod(e.paymentquickbookid);

    if (paramObject.id === undefined) {
      const localValue1 =
        JSON.parse(localStorage.getItem("ExpenseDraft")) || {};
      const x = {
        ...localValue1,
        paymentMethodId: e.value,
        Paymenttypename: e.label,
        qbPaymentmethod: e.paymentquickbookid,
      };
      setLocalValues(x);
      localStorage.setItem("ExpenseDraft", JSON.stringify(x));
    }
  };

  const handleChangeRefno = (e) => {
    setReferenceNumber(e.target.value);
    if (paramObject.id === undefined) {
      const localValue1 =
        JSON.parse(localStorage.getItem("ExpenseDraft")) || "";
      const x = { ...localValue1, referenceNumber: referenceNumber };
      setLocalValues(x);
      localStorage.setItem("ExpenseDraft", JSON.stringify(x));
    }
  };

  const HandlePrintStatusChange = (e) => {
    setPrintLater(printLater ? false : true);
  };

  useEffect(() => {
    let match = paymentMethod.find((item) => item.value == paymentMethodId);
    if (match) {
      setpaymentQB(match.label);
      setQBPaymentmethod(match?.paymentquickbookid);
    }
  }, [paymentMethodId, paymentMethod]);

  const handleSelectedtags = (e) => {
    setSelectedtags(Array.isArray(e) ? e.map((x) => x.value) : []);
    // setSelectedtags(e);
  };

  const handlePriceChange = (index, value) => {
    updatedData = [...Data];
    updatedData[index] = {
      ...updatedData[index],
      CostPrice: value == 0 || value < 0 ? "" : value,
    };

    let total = calculateTotal(
      updatedData[index].CostPrice,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    updatedData[index] = { ...updatedData[index], Total: total.toFixed(2) };

    SetData(updatedData);

    if (paramObject.id === undefined) {
      const localValue1 =
        JSON.parse(localStorage.getItem("ExpenseDraft")) || {};
      const x = {
        ...localValue1,
        ExpenseData: updatedData,
      };
      setLocalValues(x);
      localStorage.setItem("ExpenseDraft", JSON.stringify(x));
    }
  };

  const latestCheckNumberAPI = () => {
    axios
      .get(
        `${config.receivingBaseUrl}/receivings/getlatestchecknumberbyaccount?accountid=${selectedaccount}&paymenttypeid=${QBPaymentmethod}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )

      .then((res) => {
        console.log(res.data.ResponseData, "resDatacheking");
        let takeNumber = res.data.ResponseData[0]?.NextRefno;
        console.log(takeNumber, "takeNumber");

        setReferenceNumber(takeNumber);
      });
  };

  useEffect(() => {
    if (
      (paymentQB == "Check" || paymentQB == "Cash") &&
      (selectedaccount > 0 || selectedaccount != "") &&
      (paramObject.id !== undefined
        ? (prevPaymentMethodId != paymentMethodId ||
          prevSelectedaccount != selectedaccount) ? true : setReferenceNumber(prevRefNum)
        : true)
    ){
      latestCheckNumberAPI();
    }
  }, [paymentQB, selectedaccount, paymentMethodId]);

  const handleQuantityChange = (index, value) => {
    updatedData = [...Data];

    updatedData[index] = {
      ...updatedData[index],
      itemquantity: value == 0 ? "" : Number(value),
    };
    let total = calculateTotal(
      updatedData[index].CostPrice,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    updatedData[index] = { ...updatedData[index], Total: total.toFixed(2) };
    SetData(updatedData);
  };

  const handleCategoryDescriptionChange = (index, value) => {
    //Saving data in LS

    let updatedDataState = [...Data];
    updatedDataState[index] = {
      ...updatedDataState[index],
      Description: value,
    };
    SetData(updatedDataState);

    // updateTotal(updatedData);
    // setStateNew()
  };

  const handleDiscountChange = (index, value) => {
    updatedData = [...Data];
    updatedData[index] = {
      ...updatedData[index],
      itemdiscount: value == 0 ? "" : Number(value),
    };

    let total = calculateTotal(
      updatedData[index].CostPrice,
      updatedData[index].itemquantity,
      updatedData[index].itemdiscount
    );
    updatedData[index] = { ...updatedData[index], Total: total.toFixed(2) };

    SetData(updatedData);
  };

  const handleCategoryAmountChange = (index, value) => {
    updatedData = [...Data];
    updatedData[index] = {
      ...updatedData[index],
      // CostPrice: Number(value),
      CostPrice: value ? value : value,
      Total: value,
    };

    SetData(updatedData);
  };

  const handleTotalChange = (index, value) => {
    updatedData = [...Data];

    let totalvalue = value;
    let itemquantity = updatedData[index].itemquantity;
    let itemdiscount = updatedData[index].itemdiscount;
    if (itemdiscount == undefined || itemdiscount == "") {
      itemdiscount = 0;
    }

    // Calculate the subtotal after applying the discount
    let subtotal = totalvalue / (1 - itemdiscount / 100);

    // Calculate the price per quantity
    let price = subtotal / itemquantity;

    updatedData[index] = { ...updatedData[index], Total: value };
    updatedData[index] = { ...updatedData[index], CostPrice: price.toFixed(2) };

    SetData(updatedData);
  };

  const handleDeleteClick = (indexs) => {
    console.log(indexs, "valuee");
    setShowDeleteModal(true);
    setDeleteIndex(indexs);
  };

  const handleClose = () => setShowDeleteModal(false);

  const handleConfirmDelete = (i) => {
    console.log(i, "valuee1");

    const filteredData = Data.filter((item, index) => index !== i);
    SetData([]);
    setTimeout(() => {
      SetData(filteredData);
    }, 500);

    setShowDeleteModal(false);
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
  };
  const handeltagsmodelClose = () => setShowTag(false);
  const handeltagsmodelShow = () => setShowTag(true);

  const handleSubmitformodeltags = async (eventObject) => {
    if (eventObject.Tags === "") {
      toastError("Please Insert Tag Name");
      return;
    }
    setLoading(true);
    axios
      .post(
        `${config.tagBaseUrl}/tags/upsert`,
        {
          id: 0,
          ecommerecetagid: 1,
          name: eventObject.Tags,
          tagtype: "Account",
          loginuserid: Id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data);
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
          handleTagsDropdowns();
          handeltagsmodelClose();
        } else {
          toastError(ERROR_MESSAGE);
        }
        setLoading(false);
      });

    handleSubmitformodeltags();
  };

  console.log(Data, "410Data501");

  const callback = (payload) => {
    console.log(payload, "datas===>");
    if (payload != undefined && payload.length > 0) {
      const newItem = {
        ...payload[0],
        itemquantity: 1,
        receivingitemquickbookid: 0,
        ReceivingId: paramObject?.id ? paramObject?.id : 0,
        mainIndex: Data?.length + 1,
      };
      let existingItemIndex = Data?.findIndex(
        (item) =>
          item.VariationId === newItem.VariationId &&
          item.ItemId === newItem.ItemId
      );

      console.log(existingItemIndex, "existingItemIndex");

      if (newItem.Module == "Accounts") {
        existingItemIndex = -1;
      }

      console.log(existingItemIndex, "existingItemIndex");

      if (existingItemIndex !== -1) {
        const existingItem = Data[existingItemIndex];
        if (existingItem?.Module != "Accounts") {
          existingItem.itemquantity = Number(existingItem.itemquantity) + 1;
        } else {
          existingItem.itemquantity = 1;
        }
        // existingItem.Total = calculateTotal(
        //   existingItem.CostPrice,
        //   existingItem.itemquantity,
        //   existingItem.itemdiscount
        // );

        const updatedDataNew = [...Data];
        updatedDataNew.splice(existingItemIndex, 1);

        console.log(updatedDataNew, "0520 2");
        console.log([existingItem, ...updatedDataNew], "0520 2");

        SetData([existingItem, ...updatedDataNew]);

        if (paramObject.id === undefined) {
          const localValue1 =
            JSON.parse(localStorage.getItem("ExpenseDraft")) || {};
          const x = {
            ...localValue1,
            ExpenseData: [existingItem, ...updatedDataNew],
          };
          setLocalValues(x);
          localStorage.setItem("ExpenseDraft", JSON.stringify(x));
        }
        // setTimeout(() => {
        //   if (qtyInputRef.current) {
        //     qtyInputRef.current.focus();
        //   }
        // }, 0);

        updatedData = updatedDataNew;
      } else {
        SetData([newItem, ...Data]);
        if (paramObject.id === undefined) {
          const localValue1 =
            JSON.parse(localStorage.getItem("ExpenseDraft")) || {};
          const x = {
            ...localValue1,
            ExpenseData: [newItem, ...Data],
          };
          setLocalValues(x);
          localStorage.setItem("ExpenseDraft", JSON.stringify(x));
        }
        updatedData = Data.concat(newItem);
        //   setTimeout(() => {
        //     if (qtyInputRef.current) {
        //       qtyInputRef.current.focus();
        //       qtyInputRef.current.select();
        //     }
        //   }, 0);
      }
    }
    payload = "";
  };

  const searchItemInputRef = useRef(null);

  const onToggle = () => {
    console.log(toggled, "444");
    setToggled((t) => !t);
  };

  const PaymentMethodAPI = () => {
    axios
      .get(
        `${config.generalBaseUrl}/generals/transactionpaymentdropdown?module=pay_bill`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const Option = res.data.ResponseData.map((u) => ({
          label: u.Paymenttypename,
          value: u.ID,
          paymentquickbookid: u.PaymentQuickbookId,
        }));

        console.log(res.data.ResponseData, "checkdatasss");

        setPaymentMethod(Option);
      });
  };

  const handleTagsDropdowns = () => {
    // tags dropdown values
    axios
      .get(`${config.tagBaseUrl}/tags/tagsdropdown?tagtype=Account`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("tags ==>", res.data.ResponseData);
        setTagsdropdwonData(res.data.ResponseData);
        return res;
      });
  };

  //Api calls

  // const handlesubmit = () => {
  //   const Location = localStorage.getItem("Location");

  //   let reqobj = {
  //     Payeeid: selectpayee,
  //     payeetypeid: payeetypeid,
  //     accountid: selectedaccount,
  //     paymentMethodId: paymentMethodId,
  //     referenceNumber: referenceNumber,
  //     Total: ExpenseTotal,
  //     ExpenseDate: ExpenseDate,
  //     Location: Location,
  //     ID: paramObject.id || 0,
  //     loginuserid: Id,
  //     memo: memo,
  //     QuickbookPayee: QuickbookPayee,
  //     Quickbookaccount: Quickbookaccount,
  //     trnQuickbookid: trnQuickbookid,
  //     paymentQB: paymentQB,
  //     QBPaymentmethod: QBPaymentmethod,
  //   };

  //   console.log(JSON.stringify(reqobj), "reqobjdata");
  //   setLoading(true);
  //   axios
  //     .post(`${config.receivingBaseUrl}/receivings/Expenseupsert`, reqobj, {
  //       headers: {
  //         "Content-Type": "application/json;charset=UTF-8",
  //         "Access-Control-Allow-Origin": "*",
  //         Authorization: token,
  //       },
  //     })
  //     .then((res) => {
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         localStorage.removeItem("ExpenseDraft");

  //         toastSuccess(res.data.ResponseMessage);
  //         navigate(`/receiving-receipt/${res.data.ResponseID[0].ID}`);
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //     });
  // };

  console.log(Data, "DataData");

  const handlesubmit = (buttonType) => {
    // FOR VENDOR VALIDATION WHEN A/P OR A/R selected
    const payeeTypeMap = {
      "Accounts Payable (A/P)": 0,
      "Accounts Receivable (A/R)": 1,
    };

    const matchingItem = Data.find(
      (item) =>
        item.Module === "Accounts" && payeeTypeMap.hasOwnProperty(item.Items)
    );

    if (matchingItem && selectpayee == 0) {
      const payeetypeid = payeeTypeMap[matchingItem.Items];
      toastError(
        payeetypeid == 0
          ? "When you use Accounts Payable, you must choose a vendor."
          : "When you use Accounts Receivable, you need to choose a customer."
      );
      return; // Exit if selectpayee is 0
    } else if (
      (selectedaccount == 0 || selectedaccount == undefined) &&
      Data.length == 0
    ) {
      toastError(
        "Please fill required field. Additionally, ensure you enter at least one line item."
      );
    } else if (selectedaccount == 0) {
      toastError("Please fill required field");
    } else if (Data.length == 0) {
      toastError("Ensure you enter at least one line item.");
    // } else if (paymentMethodId == 0 || !paymentMethodId) {
    //   toastError("Please select payment method");
    //   return;
    } else {
      var Itemdata = Data.filter(function (salesItem) {
        return salesItem.ItemId != "";
      });

      const mappedItemDataArray = Itemdata.map((item) => ({
        ...item,
        Description: item.Description === null ? "" : item.Description,
      }));

      const isAccountReceivable = mappedItemDataArray.some(
        (el) => el.AccountTypeName === "Accounts Receivable"
      );
      const isAccountPayable = mappedItemDataArray.some(
        (el) => el.AccountTypeName === "Accounts Payable"
      );

      // Create the payment object
      let paymentData = {};
      paymentData.paymentValueXML = [];
      let paymentvaluejsonstring = JSON.stringify(paymentData);

      const Itemobj = {};
      Itemobj.receivingitemsXML = mappedItemDataArray; //Itemdata
      let itemjsonstring = JSON.stringify(Itemobj);

      let customValuesData = {};
      customValuesData.customValueXML = [];
      let customvaluejsonstring = JSON.stringify(customValuesData);

      console.log(printLater, "printLatercheck");

      const formValuesDataToSend = {
        xmlreceivingsitems: itemjsonstring,
        xmlcustomfieldvalue: customvaluejsonstring,
        xmlpaymentvalue: paymentvaluejsonstring,
        loginuserid: Id,
        total: ExpenseTotal,
        subtotal: ExpenseTotal,
        comment: memo,
        id: paramObject.id || 0,
        supplierid: selectpayee, // selectedOption.value,
        paymentcurreny: "USD",
        receivingtypeid: 7,
        locationid: Location,
        transfertolocationid: "",
        ispo: 0,
        storeaccountpayment: "",
        totalquantitypurchased: 0,
        totalquantityreceived: Data?.length,
        discountcomment: "",
        // discountentiresale: discountInputValue,
        discountentiresale: "",
        addcouponcodes: "",
        issuspended: 1,
        billno: referenceNumber || "",
        duedate: ExpenseDate,
        termsid: 0,
        termsquickbookid: "",
        receipt: "",
        tagids: "",
        accountid: selectedaccount,
        shiptocustomer: "",
        shippingadress: "",
        shipvia: "",
        receivingdate: ExpenseDate,
        supplieremail: "",
        mailingaddress: "",
        balance: ExpenseTotal,
        IsComplete: 1,
        Payeetype: payeetypeid,
        customerdata: {},
        supllierquickbookid: QuickbookPayee || 0,
        supplierName: "",
        ReceivingId: trnQuickbookid == null ? 0 : trnQuickbookid,
        Shipingadd: "",
        ReceivingTypes: 7,
        Accountrefquickbookid: Quickbookaccount,
        payeequickbookid: QuickbookPayee,
        receivingquickbookid: trnQuickbookid,
        QBPaymentmethod: paymentMethodId || 0,
        paymentQB: isCC_Credit == 1 ? "CreditCard" : paymentQB,
        paymentTypeQbId: QBPaymentmethod,
        printstatus: printLater ? 1 : 0,
        QuickBookExpense: QuickBookExpense,
        isCC_Credit: isCC_Credit,
      };
      console.log(formValuesDataToSend, "formValuesDataToSend 3");

      setLoading(true);
      axios
        .post(
          `${config.receivingBaseUrl}/receivings/upsert`,
          formValuesDataToSend,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          if (res.data.ResponseCode === "SUCCESS") {
            localStorage.removeItem("ExpenseDraft");

            toastSuccess(res.data.ResponseMessage);
            if (buttonType === "saveandnew") {
              navigate("/Expense");
              window.location.reload();
            } else {
              // navigate(`/receiving-receipt/${res.data.ResponseID}`);
              navigate("/transaction-log");
            }

            console.log(
              payeetypeid == 2 && Number(AmountPaid) > ExpenseTotal,
              AmountPaid,
              ExpenseTotal,
              payeetypeid,
              "check condition"
            );

            if (payeetypeid == 1 && Number(AmountPaid) > ExpenseTotal) {
              const total = ExpenseTotal;

              let reqobj = {
                BillId: paramObject.id,
                sbtractvalue: Number(AmountPaid) - total,
                Type: isCC_Credit === 1 ? "CreditCard" : "Expense",
              };

              axios
                .post(
                  `${config.receivingBaseUrl}/receivings/PaymentSettleInExpenseV2`,
                  reqobj
                )
                .then((res) => {})
                .catch((err) => {});
            }
          } else {
            toastError(res.data.ResponseMessage);
          }
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  const handleClear = () => {
    localStorage.removeItem("ExpenseDraft");
    window.location.reload();
  };

  useEffect(() => {
    axios
      .get(`${config.generalBaseUrl}/generals/payeedropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((response) => {
        console.log(response.data.ResponseData, "datadone=======.");
        setPayeeOptions(response.data.ResponseData);
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .get(
        `${config.accountingBaseUrl}/chartofaccounts/accountddl
        `,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("response ==>", res.data.ResponseData);
        setAccount(
          res.data.ResponseData.filter(
            (item) =>
              item.AccountType === "Bank" ||
              item.AccountType === "Credit Card" ||
              item.AccountType === "Other Current Asset"
            // || item.AccountType === "Credit Card"
          )
        );

        // setAccount(res.data.ResponseData);
      });

    PaymentMethodAPI();
    handleTagsDropdowns();

    // if (paramObject.id > 0) {
    //   setLoading(true);
    //   axios
    //     .get(
    //       `${config.receivingBaseUrl}/receivings/listofsuspendrecordByidv2?id=${paramObject.id}`,
    //       {
    //         headers: {
    //           "Content-Type": "application/json;charset=UTF-8",
    //           "Access-Control-Allow-Origin": "*",
    //           Authorization: token,
    //         },
    //       }
    //     )
    //     .then((res) => {
    //       const SuspendedData = res.data.ResponseData.unSuspendData[0];
    //       const Recevingsitem = res.data.ResponseData?.receivingItem;
    //       SetData(Recevingsitem);
    //       setmemo(SuspendedData?.Comments);
    //       setselectpayee(SuspendedData?.Supplier);
    //       setpayeetypeid(SuspendedData?.PayeeType);
    //       settrnQuickbookid(SuspendedData?.QuickbookId);
    //       setPaymentMethodId(SuspendedData?.PaymentmethodId);
    //       let label = paymentMethod.find(
    //         (el) => el.value == SuspendedData?.PaymentmethodId
    //       );
    //       setpaymentQB(label?.label);
    //       setQBPaymentmethod(label?.paymentquickbookid);
    //       setQuickbookPayee(
    //         res.data.ResponseData.supplierdetail[0].QuickBookId
    //       );
    //       setquickbookaccount(SuspendedData?.accountquickbookidexpense);
    //       setSelectedAccount(SuspendedData?.AccountID);
    //       let account =
    //         AccontDDL.find(
    //           (option) => option?.value == SuspendedData?.AccountID
    //         ) || "";
    //       console.log(account, "ExpenseItem");
    //       setselectedaccountbal(account?.Amount);
    //       setReferenceNumber(SuspendedData?.BillNo);
    //       setexpensedate(SuspendedData?.Date);
    //       setExpenseTotal(SuspendedData?.total);
    //       setLoading(false);
    //     })
    //     .catch((err) => {
    //       setLoading(false);
    //       console.log(err);
    //     });
    // }
  }, []);

  useEffect(() => {
    if (paramObject.id > 0) {
      setLoading(true);
      axios
        .get(
          `${config.receivingBaseUrl}/receivings/listofsuspendrecordByidv2?id=${paramObject.id}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          const SuspendedData = res.data.ResponseData.unSuspendData[0];
          const Recevingsitem = res.data.ResponseData?.receivingItem;
          // SetData(Recevingsitem);
          SetData(
            Recevingsitem.map((item, index) => ({
              ...item,
              mainIndex: index + 1, // Assign a proper index to each item
            }))
          );
          setmemo(SuspendedData?.Comments);
          setIsCC_Credit(SuspendedData?.IsCC_Credit || 0);
          setPrintLater(SuspendedData?.PrintStatus == 1 ? true : false);
          setselectpayee(SuspendedData?.Supplier);
          setpayeetypeid(SuspendedData?.PayeeType);
          settrnQuickbookid(SuspendedData?.QuickbookId);
          setAmountPaid(SuspendedData?.AmountPaid);
          setPaymentMethodId(SuspendedData?.PaymentmethodId);
          setPrevPaymentMethodId(SuspendedData?.PaymentmethodId);
          let label = paymentMethod.find(
            (el) => el.value == SuspendedData?.PaymentmethodId
          );
          setpaymentQB(label?.label);
          setQBPaymentmethod(label?.paymentquickbookid);
          setIsCheckSelected(SuspendedData?.Paymenttypename == "Check" ? 1 : 0);
          setQuickbookPayee(
            res.data.ResponseData.supplierdetail[0].QuickBookId
          );
          setquickbookaccount(SuspendedData?.accountquickbookidexpense);
          setSelectedAccount(SuspendedData?.AccountID);
          setPrevSelectedAccount(SuspendedData?.AccountID);
          let account =
            AccontDDL.find(
              (option) => option?.value == SuspendedData?.AccountID
            ) || 0;
          console.log(account, "ExpenseItem");
          setselectedaccountbal(SuspendedData?.AccountBalance);
          setReferenceNumber(SuspendedData?.BillNo);
          setPrevRefNum(SuspendedData?.BillNo);
          setexpensedate(SuspendedData?.ReceivingDate);
          setExpenseTotal(SuspendedData?.total);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
  }, [paramObject.id]);

  useEffect(() => {
    const tagValue = selectedtags?.map((e) => Number(e));
    const filteredTagsData = TagsList?.filter((tag) =>
      tagValue?.includes(tag.value)
    );
    setTag(filteredTagsData);
  }, [selectedtags]);
  // Dropdowns

  let TagsList = [];
  const Tags = tagsdropdwonData.map((u, i) => {
    TagsList[i] = { label: u.Name, value: u.ID };
  });

  let payeeoption = [];
  const manufacturedropdownvalue = payeeoptions.map((u, i) => {
    payeeoption[i] = {
      label: u.CompanyName + " " + `   (${u.Type})`,
      value: u.ID,
      Type: u.Type,
      QuickBookId: u.QuickBookId,
    };
  });

  console.log(Account, "AccountAccount");

  let AccontDDL = [];
  const manufacturedropdownvalues = Account.filter((e) =>
    isCC_Credit === 1 ? e.AccountTypeID === 11 : true
  ).map((u, i) => {
    AccontDDL[i] = {
      label: u.Name,
      value: u.ID,
      Amount: u.Amount,
      QuickBookId: u.QuickbookId,
      AccountTypeID: u.AccountTypeID,
      parentName: u.ParentName ? u.ParentName.trim() : "",
      AccountType: u.AccountType,
    };
  });

  // Local Drafting handling

  useEffect(() => {
    const Draftdata = JSON.parse(localStorage.getItem("ExpenseDraft"));
    console.log(Draftdata, "ExpenseDraft");
    if (paramObject.id === undefined && Draftdata !== null) {
      setPaymentMethodId(Draftdata?.paymentMethodId);
      setselectpayee(Draftdata?.payee);
      setpayeetypeid(Draftdata?.payeetypeid);
      setQuickbookPayee(Draftdata?.payeeqb);
      setSelectedAccount(Draftdata?.Selectedaccount);
      setquickbookaccount(Draftdata?.quickbookaccount);
      setReferenceNumber(Draftdata?.referenceNumber);
      setpaymentQB(Draftdata?.Paymenttypename);
      if (Draftdata?.ExpenseData?.length > 0) {
        SetData(Draftdata?.ExpenseData);
      }
      setQBPaymentmethod(Draftdata?.qbPaymentmethod);
      setselectedaccountbal(Draftdata?.selectedaccountbal);
      setmemo(Draftdata?.memo);
    }
  }, []);

  useEffect(() => {
    let expenseTotal = Data.reduce((acc, curr) => {
      return acc + Number(curr.Total);
    }, 0);

    setExpenseTotal(expenseTotal);

    if (paramObject.id === undefined) {
      const localValue1 =
        JSON.parse(localStorage.getItem("ExpenseDraft")) || {};
      const x = {
        ...localValue1,
        ExpenseData: Data,
      };
      setLocalValues(x);
      localStorage.setItem("ExpenseDraft", JSON.stringify(x));
    }
  }, [Data]);

  const selectedPaymentMethod = paymentMethod?.find(
    (option) => option.value === paymentMethodId
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          {/* Page Header */}
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row">
              <div className="breadcrumb-position">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    {isCC_Credit === 1 ? "Credit Card" : "Expense"}
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div
            style={{ backgroundColor: "white" }}
            className="mb-3  card-body rounded-3"
          >
            <div className="card-header">
              {!QuickBookExpense && AllowQBSync && (
                <QuickbookSyncMessageComponent type="Expense" />
              )}
              <p className="card-title p-lg">
                <button
                  className="btn btn-sm pt-0 ps-0"
                  type="button"
                  data-bs-target="#RecentTransactionsModal"
                  data-bs-toggle="modal"
                >
                  <i class="fa fa-history fs-4"></i>
                </button>{" "}
                {isCC_Credit === 1 ? "Credit Card" : "Expense"}
              </p>
              <div className="row pb-5">
                <div className="col-sm-3">
                  <label className="col-form-label col-md-12 form-label">
                    Payee
                    {/* <span className="text-danger">*</span> */}
                  </label>

                  <div className="col-md-12">
                    <div>
                      <Select
                        className="custom-search-select"
                        name="supplierid"
                        id="supplierid"
                        placeholder="Select Payee"
                        options={payeeoption}
                        onChange={handlepayee}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        value={
                          payeeoption.find(
                            (option) =>
                              option?.value == selectpayee &&
                              option?.Type ==
                                (payeetypeid == 0
                                  ? "Supplier"
                                  : payeetypeid == 1
                                  ? "Customer"
                                  : "Employee")
                          ) || ""
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="col-sm-5">
                  <div className="row">
                    <label className="col-form-label col-md-12 form-label">
                      Account
                      <span className="text-danger">*</span>
                    </label>
                    <div className="col-md-8">
                      <Select
                        className={` custom-search-select`}
                        value={
                          AccontDDL.find(
                            (option) => option?.value == selectedaccount
                          ) || ""
                        }
                        onChange={handleaccount}
                        options={AccontDDL}
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        isClearable={true}
                        id="Account"
                        name="Account"
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        formatOptionLabel={({
                          label,
                          parentName,
                          AccountType,
                        }) => (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              width: "100%",
                            }}
                          >
                            <span>{label}</span>
                            <span
                              style={{
                                fontStyle: "italic",
                                color: "#666",
                                marginLeft: "1rem",
                              }}
                            >
                              {parentName
                                ? `Sub-account of ${parentName}`
                                : AccountType}
                            </span>
                          </div>
                        )}
                      />
                    </div>
                    <div className="col-sm-4 pt-2">
                      <label className="col-form-label ">
                        Balance :
                        {CurrencySymbols(
                          selectedaccountbal || 0,
                          CurrencySymbol,
                          FractionDigits
                        )}
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-sm-2"></div>
                {/* <div className="col-sm-1"></div> */}

                <div className="col-sm-2">
                  <p>AMOUNT</p>
                  <label
                    className="col-md-7  "
                    style={{ fontWeight: "bold", fontSize: "35px" }}
                  >
                    {CurrencySymbols(
                      Number(ExpenseTotal),
                      CurrencySymbol,
                      FractionDigits
                    )}
                  </label>
                </div>
              </div>
              <div style={{ borderBottom: "1px solid #e8eaea" }}></div>
              <div className="row pt-4 d-flex justify-content-between align-items-start pb-4">
                {/* Payment Date */}
                <div className="col-md-2">
                  <p className="col-form-label">Payment Date:</p>
                  <CommonDatePicker
                    FinalDate={ExpenseDate}
                    handleDateChange={setexpensedate}
                  />
                </div>

                {/* Payment Method */}
                {isCC_Credit == 0 ? (
                  <div className="col-md-2">
                    <label className="col-form-label col-md-12 form-label">
                      Payment Method:
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <div>
                      <Select
                        options={paymentMethod}
                        placeholder="Select Method"
                        backspaceRemovesValue={false}
                        controlShouldRenderValue={true}
                        hideSelectedOptions={true}
                        styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                        id="PaymentMethod"
                        name="PaymentMethod"
                        onChange={(event) => handleChangePaymet(event)}
                        value={paymentMethod?.find(
                          (option) => option.value === paymentMethodId
                        )}
                        className="custom-search-select"
                        // disabled={selectedPaymentMethod?.label === "Check"}
                        // isDisabled={paramObject.id > 0 && selectedPaymentMethod?.label === "Check"}
                        isDisabled={paramObject.id > 0 && isCheckSelected == 1}
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}

                {/* Reference Number */}
                <div className="col-md-2">
                  <p className="col-form-label">Reference Number:</p>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Ref No."
                    name="ReferenceNumber"
                    id="ReferenceNumber"
                    onChange={(event) => handleChangeRefno(event)}
                    value={printLater ? "To Print" : referenceNumber}
                  />
                </div>
                {paymentQB == "Check" && (
                  <div className="col-md-1 ">
                    <div className=" col-form-label">Print Later</div>
                    <input
                      type="checkbox"
                      checked={printLater}
                      style={{ transform: "scale(1.2)", margin: "5px" }}
                      onChange={(event) => HandlePrintStatusChange(event)}
                    />
                  </div>
                )}
                <div
                  className={`${
                    paymentQB == "Check" ? "col-md-5" : "col-md-6"
                  } `}
                ></div>
              </div>

              <div style={{ borderBottom: "1px solid #e8eaea" }}></div>

              <div className="row pt-3 d-flex justify-content-between align-items-start">
                <div className="row">
                  <div className="row mt-3">
                    <label className="form-label">Tags</label>
                    <div className="col-md-5">
                      <div className="input-group">
                        <Select
                          backspaceRemovesValue={false}
                          controlShouldRenderValue={true}
                          hideSelectedOptions={true}
                          // isClearable={true}
                          isMulti={true}
                          onChange={handleSelectedtags}
                          options={TagsList}
                          placeholder=""
                          styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                          id="Tags"
                          name="Tags"
                          className="w-75  custom-search-select"
                          value={tag}
                        />

                        <button
                          type="button"
                          className="btn btn-sm btn-secondary ml-2"
                          data-bs-toggle="modal"
                          data-bs-target="#ManageDataModal"
                          onClick={() => handeltagsmodelShow()}
                        >
                          Add Tags
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{ backgroundColor: "white" }}
            className="pl-4 mt-4 pt-5 mb-3"
          >
            <div className="card-body">
              <div className="row">
                <div className="d-flex w-6 ">
                  <div className="custom-fill-available">
                    <SearchableDropdown
                      SupplierID={selectpayee}
                      callback={callback}
                      options={[]}
                      value={7}
                      selectedReceiveDropdown={toggled == true ? 1 : 0}
                      isExpense={true}
                      toggele={toggled}
                      searchItemInputRef={searchItemInputRef}
                    />
                  </div>

                  <div className=" d-flex form-check form-switch gap-2 ">
                    <input
                      className="form-check-input mt-3 ms-2"
                      type="checkbox"
                      id="toggle-button"
                      // style={{
                      //   height: "20px",
                      //   width: "35px",
                      //   marginLeft: "20px",
                      //   marginBottom: "20px",
                      // }}
                      checked={toggled}
                      onChange={onToggle}
                    />
                    <label
                      className="form-label ms-2 mt-2"
                      htmlFor="toggle-button"
                    >
                      {toggled ? "Category" : "Items"}
                    </label>
                  </div>
                </div>
                <div className="mt-1 col-md-12 table custom-table">
                  <table>
                    <thead style={{ backgroundColor: "white" }}>
                      <th>NO </th>
                      <th> Cost Price </th>
                      <th>Qty </th>
                      <th> Disc.(%)</th>
                      <th> Total</th>
                    </thead>
                    <tbody>
                      {Data?.map((item, index) => {
                        const filteredIndex = Data.indexOf(item);
                        return (
                          <>
                            <tr
                              className={
                                "gridrow-" +
                                (filteredIndex % 2 ? "even" : "odd")
                              }
                            >
                              {
                                <>
                                  <td rowSpan={2}>{item.mainIndex}</td>
                                  {item.Module !== "Accounts" ? (
                                    <td colSpan={7} className="p-1">
                                      <Link
                                        type="button"
                                        // onClick={(e) =>
                                        //   handleItemsDetailsData(item)
                                        // }
                                        data-bs-target="#ItemsDetailsModal"
                                        data-bs-toggle="modal"
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                        }}
                                      >
                                        <p
                                          className="word-break-data"
                                          style={{
                                            fontSize: "14px",
                                            fontWeight: 500,
                                          }}
                                        >
                                          {item.VariationName != "" &&
                                          item.VariationName != null
                                            ? item.VariationName
                                            : item.ItemName}
                                        </p>
                                      </Link>
                                    </td>
                                  ) : (
                                    <td></td>
                                  )}
                                </>
                              }
                            </tr>
                            <tr
                              key={item.modifyid}
                              className={
                                "gridrow-" +
                                (filteredIndex % 2 ? "even" : "odd")
                              }
                            >
                              {item.Module !== "Accounts" ? (
                                <td className="table-control-td">
                                  <span className="table-control-label">
                                    Cost Price
                                  </span>
                                  <input
                                    type="text"
                                    value={`${CurrencySymbol} ${
                                      item.CostPrice ?? 0
                                    }`}
                                    // value={item.CostPrice ?? 0} // Ensure a default value for controlled input
                                    className="form-control form-control-sm"
                                    onChange={(e) => {
                                      const rawValue = e.target.value
                                        .replace(CurrencySymbol, "")
                                        .trim();

                                      e.target.value = rawValue;

                                      const value = e.target.value || 0; // Ensure the value is numeric
                                      handlePriceChange(filteredIndex, value);
                                      // if (value >= 0) {
                                      //   handlePriceChange(filteredIndex, value);
                                      // }
                                    }}
                                    onFocus={(event) => event.target.select()}
                                    onBlur={(event) => {
                                      let rawValue = event.target.value
                                        .replace(CurrencySymbol, "")
                                        .trim();

                                      let numericValue =
                                        parseFloat(rawValue) || 0;
                                      numericValue = numericValue.toFixed(2); // Format to 2 decimal places

                                      event.target.value = numericValue;
                                      handlePriceChange(
                                        filteredIndex,
                                        event.target.value
                                      );
                                    }}
                                  />
                                </td>
                              ) : (
                                <td className="table-control-td">
                                  <span className="table-control-label">
                                    Category :
                                  </span>
                                  <p>
                                    {" "}
                                    {item.ItemName
                                      ? item.ItemName
                                      : item.Items}{" "}
                                  </p>
                                </td>
                              )}

                              {item.Module !== "Accounts" ? (
                                <td className="table-control-td">
                                  <span className="table-control-lable">
                                    Qty
                                  </span>
                                  <input
                                    type="number"
                                    ref={index === 0 ? qtyInputRef : null}
                                    value={item.itemquantity}
                                    // min={1}
                                    // max={item.ItemCurrentQuantity}
                                    className="form-control form-control-sm"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (value >= 0) {
                                        handleQuantityChange(
                                          filteredIndex,
                                          value
                                        );
                                      }
                                    }}
                                    // onKeyDown={handleQtyKeyDown}
                                  />
                                </td>
                              ) : (
                                <td>
                                  <span className="table-control-label">
                                    Description
                                  </span>
                                  <input
                                    type="text"
                                    value={
                                      item.Description == null
                                        ? ""
                                        : item.Description
                                    }
                                    className="form-control"
                                    onChange={(e) =>
                                      handleCategoryDescriptionChange(
                                        filteredIndex,
                                        e.target.value
                                      )
                                    }
                                  />
                                </td>
                              )}

                              {item.Module !== "Accounts" ? (
                                <td className="table-control-td">
                                  <span className="table-control-lable">
                                    Discount
                                  </span>
                                  <input
                                    type="number"
                                    value={item.itemdiscount}
                                    className="form-control form-control-sm"
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (value >= 0) {
                                        handleDiscountChange(
                                          filteredIndex,
                                          e.target.value
                                        );
                                      }
                                    }}
                                  />
                                </td>
                              ) : (
                                <td>
                                  <span className="table-control-label">
                                    Amount
                                  </span>
                                  <input
                                    type="text"
                                    ref={index === 0 ? qtyInputRef : null}
                                    // value={item.CostPrice}
                                    value={`${CurrencySymbol} ${
                                      item.CostPrice === ""
                                        ? ""
                                        : item.CostPrice
                                    }`}
                                    className="form-control"
                                    onChange={(event) => {
                                      const rawValue = event.target.value
                                        .replace(CurrencySymbol, "")
                                        .trim();

                                      event.target.value = rawValue;
                                      console.log(
                                        rawValue,
                                        event.target.value,
                                        "value"
                                      );

                                      handleCategoryAmountChange(
                                        filteredIndex,
                                        event.target.value
                                      );
                                    }}
                                    onFocus={(event) => event.target.select()}
                                    onBlur={(event) => {
                                      let rawValue = event.target.value
                                        .replace(CurrencySymbol, "")
                                        .trim();

                                      let numericValue =
                                        parseFloat(rawValue) || 0;
                                      numericValue = numericValue.toFixed(2); // Format to 2 decimal places

                                      event.target.value = numericValue;
                                      handleCategoryAmountChange(
                                        filteredIndex,
                                        event.target.value
                                      );
                                    }}
                                  />
                                </td>
                              )}
                              {item.Module !== "Accounts" ? (
                                <td className="table-control-td">
                                  <span className="table-control-lable">
                                    Total
                                  </span>
                                  <input
                                    type="text"
                                    // value={calculateTotal(item.UnitPrice, item.itemquantity, item.itemdiscount)}
                                    // value={item.Total}
                                    value={`${CurrencySymbol} ${item.Total}`}
                                    className="form-control form-control-sm"
                                    onChange={(e) => {
                                      const rawValue = e.target.value
                                        .replace(CurrencySymbol, "")
                                        .trim();

                                      e.target.value = rawValue;

                                      // if (value >= 0) {
                                      handleTotalChange(
                                        filteredIndex,
                                        e.target.value
                                      );
                                      // }
                                    }}
                                    onFocus={(event) => event.target.select()}
                                    onBlur={(event) => {
                                      let rawValue = event.target.value
                                        .replace(CurrencySymbol, "")
                                        .trim();

                                      let numericValue =
                                        parseFloat(rawValue) || 0;
                                      numericValue = numericValue.toFixed(2); // Format to 2 decimal places

                                      event.target.value = numericValue;
                                      handleTotalChange(
                                        filteredIndex,
                                        event.target.value
                                      );
                                    }}
                                  />
                                </td>
                              ) : (
                                <td></td>
                              )}

                              <td>
                                <i
                                  className="fa fa-trash text-red fa-2x"
                                  onClick={() => handleDeleteClick(index)}
                                ></i>
                                <div
                                  className={`modal ${
                                    showDeleteModal ? "d-block" : ""
                                  } `}
                                  tabIndex="-1"
                                >
                                  <div
                                    className="modal-dialog modal-sm modal-dialog-centered"
                                    role="document"
                                  >
                                    <div className="modal-content">
                                      <div className="modal-header">
                                        <h6 className="modal-title">
                                          Confirmation
                                        </h6>
                                        <button
                                          type="button"
                                          className="btn-close"
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                          onClick={handleClose}
                                        >
                                          <span aria-hidden="true">×</span>
                                        </button>
                                      </div>
                                      <div className="modal-body">
                                        <div className="row">
                                          <div className="col-lg-12">
                                            <p>
                                              Are you sure you want to delete
                                              this row?
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="modal-footer justify-content-center">
                                        {/* {checkUserPermission(PERMISSION_DELETE) ? ( */}
                                        <button
                                          type="button"
                                          className="btn btn-primary"
                                          onClick={() =>
                                            handleConfirmDelete(deleteIndex)
                                          }
                                        >
                                          Delete
                                        </button>
                                        {/* ) : (
                      ""
                    )} */}
                                        <button
                                          type="button"
                                          className="btn btn-secondary"
                                          onClick={handleCancelDelete}
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="col-md-4"></div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <div>
                <div className="form-group mb-0">
                  <label className="col-form-label col-md-1 form-label">
                    Memo
                  </label>
                  <div className="col-md-12  mt-2">
                    <textarea
                      rows="8"
                      cols="50"
                      value={memo}
                      onChange={Handelmemo}
                    ></textarea>
                  </div>
                </div>
              </div>
              <div>
                <div className="form-group ">
                  <label className="col-form-label col-md-3 form-label">
                    Attachments
                  </label>
                  <div className="col-md-9 dotted-border p-3">
                    <input
                      id="SelectImage"
                      name="SelectImage"
                      type="file"
                      value={selectedImage}
                      accept="image/*"
                      handleChange={_handleFileChange}
                      className="form-control form-control-sm"
                    />
                    {ImageUrl && (
                      <Link to={ImageUrl} target="_blank">
                        Attachment Link
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-6 mt-5">
              {paramObject.id > 0 && (
                <div className="flex-row">
                  <div className="p-2 col-md-12">
                    <CommonPreviousInvoiceComponent
                      moduleType="Expense"
                      moduleId={paramObject.id}
                      // invoiceTotal={paymentAmount}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              gap: "1rem",
              justifyContent: "flex-end",
            }}
          >
            {(paramObject.id === 0 || paramObject.id === undefined) && (
              <button
                className="btn btn-sm btn-secondary mt-3 mb-3"
                onClick={() => handleClear()}
                style={{ marginTop: "20px" }}
              >
                Clear Data
              </button>
            )}
            <button
              className="btn btn-sm btn-secondary mt-3 mb-3"
              onClick={() => navigate(-1)}
              style={{ marginTop: "20px" }}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-sm btn-primary mt-3 mb-3"
              onClick={() => {
                handlesubmit("saveandclose");
              }}
            >
              Save & Close
            </button>
            <button
              type="submit"
              className="btn btn-sm btn-secondary mt-3 mb-3"
              onClick={() => {
                handlesubmit("saveandnew");
              }}
            >
              Save & New
            </button>

            {/* <button
              className="btn btn-sm btn-secondary mt-3 mb-3"
              onClick={() => {
                localStorage.removeItem("ExpenseDraft");
                window.location.reload();
              }}
            >
              Clear data
            </button> */}
          </div>
        </div>
      </div>

      <Modal
        show={showtag}
        onHide={handleClose}
        className="modal-lg"
        id="ManageDataModal"
      >
        <Modal.Header>
          <Modal.Title>Add Tags </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handeltagsmodelClose}
          >
            x
          </button>
        </Modal.Header>
        <Formik
          {...props}
          initialValues={formValuesfortagmodel}
          onSubmit={handleSubmitformodeltags}
          enableReinitialize
        >
          {({ values, errors, touched, handleChange, handleBlur }) => (
            <Form>
              <Loader loading={loading} />
              <div className="modal-body">
                <div className="form-group row">
                  <label className="col-form-label col-md-3 align-center">
                    Tags
                  </label>
                  <div className="col-md-9 mt-2">
                    <Field
                      type="text"
                      name="Tags"
                      id="Tags"
                      placeholder="Enter Tag Name"
                      className="form-control form-control-sm"
                      onBlur={handleBlur}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="col-lg-12 justify-content-right">
                  <button type="submit" className="btn btn-primary btn-md me-2">
                    Submit
                  </button>
                  <button
                    type="button"
                    className="btn btn-dark btn-md me-1"
                    onClick={handeltagsmodelClose}
                  >
                    Close
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default ExpenseNewLayout;

// Item SearchableDropdown
const SearchableDropdown = ({
  SupplierID,
  callback,
  disabled,
  selectedReceiveDropdown,
  readonly,
  value,
  isExpense,
  toggele,
  searchItemInputRef,
}) => {
  const searchResultRef = useRef(null);
  const token = localStorage.getItem("Token");
  const location = localStorage.getItem("Location");
  const Id = localStorage.getItem("ID");
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [entervalue, setEnterValue] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [loadingImage, setLoadingImage] = useState(false);
  console.log(toggele, "7777");

  //For Toaster
  const [show, setShow] = useState(false);
  const [barcodedisplay, setBarcodeDisplay] = useState("");

  //   useScanDetection({
  //     onComplete: setValue,
  //     minLength: 13 // EAN13
  // });

  useEffect(() => {
    //  fetchData();

    const timer = setTimeout(() => {
      if (inputValue) {
        // Make your API call here
        fetchData();
      }
    }, 500); // Adjust the delay according to your needs (in milliseconds)

    return () => {
      clearTimeout(timer);
    };
  }, [inputValue, selectedReceiveDropdown]);

  // Click outside to hide search results
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        searchResultRef.current &&
        !searchResultRef.current.contains(event.target)
      ) {
        setSuggestions([]);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [searchResultRef]);

  // Fetch data from an API
  const fetchData = async () => {
    if (inputValue != "") {
      setSuggestions([]);
      setLoadingImage(true);
      let isReceiving = 1;
      let itemsearchtype = "";
      if (selectedReceiveDropdown == 1) {
        isReceiving = 0;
      }

      console.log(selectedReceiveDropdown, "selectedReceiveDropdown");

      // if (value == 5) {
      //   itemsearchtype = "vendorcredit";
      // }

      if (toggele == true) {
        itemsearchtype = "vendorcredit";
      }
      await axios
        .get(
          `${
            config.itemsBaseUrl
          }/items/searchforaccount?searchparam=${encodeURIComponent(
            inputValue.trim()
          )}&iscategory=${selectedReceiveDropdown}&supplierid=${
            SupplierID > 0 ? SupplierID : 0
          }&locationid=${location}&customerid=0&itemsearchtype=${itemsearchtype}&isservice=${0}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          console.log("ressssspsosossns", response.data.ResponseData);
          if (response.data.ResponseData?.length > 0) {
            const data = response.data?.ResponseData;
            // const barcodedata= data.find((i,obj)=>{
            //    return obj.Itemnumber==inputValue
            // })
            // if(entervalue==1){
            //   setSuggestions([])
            //   setTableData([...tableData,barcodedata])
            // }else{
            // if (data[0].ItemId > 0) {
            //   setSuggestions(data);
            // }

            // if(barcodedisplay =="Enter") {
            //   handleInputClick(
            //     data[0].ItemId,
            //     data[0].ItemName,
            //     data[0].VariationName,
            //     data[0].CostPrice,
            //     data[0].UnitPrice,
            //     data[0].Itemquantity,
            //     data[0].Description,
            //     data[0].VariationId,
            //     data[0].AttributeId,
            //     data[0].Module,
            //     data[0].CategoryID,
            //     data[0].CategoryName,
            //     data[0].Itemnumber,
            //     data[0].Allowaltdescription,
            //     data[0].IsItemserialnumber,
            //     data[0].VariationQuantity)
            // }else{
            //   setSuggestions(data);
            // }
            console.log(data, "testdata1");
            const itemarray = data[0]?.Itemnumber
              ? data[0]?.Itemnumber?.split(",")
              : "";
            if (data.length === 1 && itemarray.includes(inputValue)) {
              handleInputClick(
                data[0].ItemId,
                data[0].ItemName,
                data[0].VariationName,
                data[0].CostPrice,
                data[0].UnitPrice,
                data[0].Itemquantity === null ? 0 : data[0].Itemquantity,
                data[0].Description,
                data[0].VariationId,
                data[0].AttributeId,
                data[0].Module,
                data[0].CategoryID,
                data[0].CategoryName,
                data[0].Itemnumber,
                data[0].Allowaltdescription,
                data[0].IsItemserialnumber,
                data[0].VariationQuantity,
                data[0].QuickbookId,
                data[0].AccountTypeName
              );
              // setTableData([...tableData,...data])
            } else {
              console.log(data, "testdata2");
              setSuggestions(data);
              setLoadingImage(false);
            }
            // }
          } else {
            toastError("No Item Found");
            setLoadingImage(false);
          }
        })
        .catch((error) => {});
    } else {
      setSuggestions([]);
    }
  };

  console.log(suggestions, "suggestions");

  const handleInputChange = (event) => {
    const value = event.target.value;
    setInputValue(value);

    if (!value) {
      setSuggestions([]);
    }
  };

  const handleToast = () => {
    if (readonly === true && !isExpense) {
      toastError("Please Select a Supplier First");
      // toastError(
      //   isExpense
      //     ? "Please Select a Payee First"
      //     : "Please Select a Supplier First"
      // );
    }
  };

  const [cursor, setcursor] = useState(0);

  let barcodeScan = "";

  const handleKeyDown = (e) => {
    console.log("log : e.keyCode =>", e.keyCode, e.key, e.target.value);
    // console.log("log : e.keyCode =>", e);

    // barcodeScan += e.key;

    // console.log(barcodeScan.length,"barcodeScanlength")

    // if(e.keyCode === 13 && barcodeScan.length > 3 ) {
    //   setBarcodeDisplay(barcodeScan)
    //   return
    // }

    console.log(suggestions, "suggestionsaa");

    if (e.keyCode === 13 || e.key === "Enter") {
      const item = suggestions[cursor];
      handleInputClick(
        item.ItemId,
        item.ItemName,
        item.VariationName,
        item.CostPrice,
        item.UnitPrice,
        item.Itemquantity,
        item.Description,
        item.VariationId,
        item.AttributeId,
        item.Module,
        item.CategoryID,
        item.CategoryName,
        item.Itemnumber,
        item.Allowaltdescription,
        item.IsItemserialnumber,
        item.VariationQuantity,
        item.QuickbookId,
        item.AccountTypeName
      );
    } else if (e.keyCode === 38 && cursor > 0) {
      setcursor(cursor - 1);
    } else if (e.keyCode === 40 && cursor < suggestions.length - 1) {
      setcursor(cursor + 1);
    }

    // setTimeout(()=>{
    //   barcodeScan=""
    // },100)
  };
  console.log("log :  cursor =>", cursor);

  const handleInputClick = (
    pItemId,
    pItemName,
    pVariationName,
    pCostPrice,
    pUnitPrice,
    pItemQuantity,
    pDescription,
    pVariationId,
    pAttributeId,
    pModule,
    pCategoryID,
    pCategoryName,
    pItemnumber,
    pAllowaltdescription,
    pIsItemserialnumber,
    pVariationQuantity,
    pQuickbookID,
    AccountTypeName

    // pItemKitId
  ) => {
    console.log("log : call function");
    if (pModule == "ItemKit") {
      axios
        .get(
          `${config.itemKitsBaseUrl}/itemkits/itemkitsitemslisting?itemkitid=${pItemId}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((response) => {
          if (response != "" && response != null) {
            const data = response.data.ResponseData;
            setSuggestions(data, () => {
              console.log("Suggestions", suggestions);
            });

            let tablesDatas = data.map((item) => ({
              ReceivingItemID: 0,
              ItemId: item.ItemId,
              ReceivingId: 0,
              CostPrice: item.CostPrice,
              UnitPrice: item.UnitPrice,
              ItemName: item.ItemName,
              VariationName: item.VariationName,
              itemquantity: selectedReceiveDropdown === 1 ? 0 : 1,
              ItemCurrentQuantity: item.VariationQuantity, // item.Itemquantity,
              itemdiscount: 0,
              Description: item.Description,
              VariationId: item.VariationId,
              AttributeId: item.AttributeId,
              Module: item.Module,
              Itemkitid: item.Itemkitid,
              CategoryID: item.CategoryID,
              Total: item.CostPrice,
              CategoryName: item.CategoryName,
              Itemnumber: item.Itemnumber,
              Allowaltdescription: item.Allowaltdescription,
              IsItemserialnumber: item.IsItemserialnumber,
              quickbookid: item.QuickbookID,
              AccountTypeName: item.AccountTypeName,
            }));

            setTableData([tablesDatas[0]]); // modify this line
            setSuggestions([]);
          }
        })
        .catch((error) => {});
    } else {
      const selectedOption = {
        ReceivingItemID: 0,
        ItemId: pItemId,
        ReceivingId: 0,
        CostPrice: selectedReceiveDropdown === 1 ? 0 : pCostPrice,
        UnitPrice: pUnitPrice,
        ItemName: pItemName,
        VariationName: pVariationName,
        itemquantity: 1,
        ItemCurrentQuantity: pItemQuantity, // pItemQuantity,
        itemdiscount: 0,
        Description: pDescription,
        VariationId: pVariationId,
        AttributeId: pAttributeId,
        Module: pModule,
        Itemkitid: 0,
        Total: pCostPrice,
        CategoryID: pCategoryID,
        CategoryName: pCategoryName,
        Itemnumber: pItemnumber,
        Allowaltdescription: pAllowaltdescription,
        IsItemserialnumber: pIsItemserialnumber,
        itemquickbookid: pQuickbookID,
        AccountTypeName: AccountTypeName,
      };

      setSuggestions([selectedOption]);
      setTableData([selectedOption]);
    }

    setInputValue("");
    setSuggestions([]);
  };

  useEffect(() => {
    console.log(tableData, "tableData===123");
    const locationItemData = tableData.filter((locationItem) => {
      return locationItem.ItemId !== "";
    });

    callback(locationItemData);
  }, [tableData]);

  return (
    <div className="">
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="">
          <div className="input-group flex-nowrap">
            <span className="input-group-text" id="addon-wrapping">
              <Link to="/manage-items">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                  <path
                    fillRule="evenodd"
                    d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                  />
                </svg>
              </Link>
            </span>
            <div
              style={{
                position: "relative",
                display: "inline-block",
                width: "100%",
              }}
            >
              <input
                ref={searchItemInputRef}
                type="text"
                className={`form-control form-control-sm ${
                  isExpense ? "" : "border-size-input"
                }`}
                placeholder={
                  selectedReceiveDropdown === 1
                    ? "Select category"
                    : "Type item name or scan barcode"
                }
                value={inputValue}
                onChange={handleInputChange}
                onClick={handleToast}
                disabled={disabled}
                readOnly={isExpense ? false : readonly}
                onKeyDown={handleKeyDown}
                style={{
                  borderTopLeftRadius: "0px",
                  borderBottomLeftRadius: "0px",
                }}
              />
              {loadingImage && (
                <div
                  style={{ position: "absolute", right: "5px", top: "10px" }}
                >
                  <img
                    src={loadingimage}
                    alt="Loading..."
                    style={{ width: "20px", height: "20px" }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        {suggestions.length > 0 ? (
          <div ref={searchResultRef} className="dropdown">
            <ul
              className="dropdown-menu show dropdown-suggestion"
              style={{ overflow: "auto", width: "139% ", maxWidth: "782px" }}
            >
              {suggestions.map((item, index) => (
                <li
                  // className="border-bottom"
                  className={
                    cursor === index ? "border-bottom active" : "border-bottom"
                  }
                  key={item.ItemId}
                  onClick={() =>
                    handleInputClick(
                      item.ItemId,
                      item.ItemName,
                      item.VariationName,
                      item.CostPrice,
                      item.UnitPrice,
                      item.Itemquantity,
                      item.Description,
                      item.VariationId,
                      item.AttributeId,
                      item.Module,
                      item.CategoryID,
                      item.CategoryName,
                      item.Itemnumber,
                      item.Allowaltdescription,
                      item.IsItemserialnumber,
                      item.VariationQuantity,
                      item.QuickbookId,
                      item.AccountTypeName
                      // item.ItemKitId
                    )
                  }
                >
                  {isExpense ? (
                    <div
                      key={item.ItemId}
                      // to="/manage-receiving?expense=true"
                      // href="#"
                      // className="dropdown-item"
                      style={{ cursor: "pointer" }}
                      className={
                        cursor === index
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      data-name={item.ItemName?.toLowerCase()}
                    >
                      <img
                        src={item.ImageName || Noimage}
                        onError={(e) => {
                          e.currentTarget.src = Noimage;
                        }}
                        alt={item.ItemName}
                        className="img-thumbnail rounded-circle m-2"
                        width="55"
                        height="55"
                      />

                      <div className="customer-info">
                        <strong className="name word-break-data">
                          {item.ItemName}{" "}
                          {item.VariationName ? `(${item.VariationName})` : ""}
                          <div
                            className="ml-auto sync-label "
                            // variant="success"
                            // style={{ position: "absolute", right: "5px" }}
                          >
                            <div style={{}}> {item.Module}</div>
                          </div>
                          {/* <div style={{marginTop:"20px"}}>
             {item.QuickbookId > 0 && (
                    <div style={{ marginTop:"30px"}}
                      className="sync-label">
                      <i
                        className="fa fa-circle"
                        style={{ fontSize: "14px", color: "green" }}
                      ></i> {" "}
                      QB Sync
                    </div>
                  )}
             </div> */}
                        </strong>
                        {item.Module === "Accounts" ? (
                          <>
                            <div>Account Type: {item.AccountTypeName}</div>
                            <div>{item.AccountDeatilsTypeName}</div>
                          </>
                        ) : (
                          <>
                            <div>
                              {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)}{" "}
                      | Promo Price:{" "}
                      {parseFloat(item.PromoPrice).toFixed(2)}| Unit
                      Price: {parseFloat(item.UnitPrice).toFixed(2)} */}
                              {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)} | Qty: {parseInt(item.Itemquantity)} */}
                              Cost Price:{" "}
                              {parseFloat(item.CostPrice).toFixed(2)} | Qty:{" "}
                              {parseInt(item.Itemquantity)}
                            </div>
                            <div>Categories: {item.CategoryName}</div>
                            <div style={{ display: "flex", float: "right" }}>
                              {item.QuickbookId > 0 && (
                                <span>
                                  <i
                                    className="fa fa-circle"
                                    style={{ fontSize: "14px", color: "green" }}
                                  ></i>{" "}
                                  QB Sync
                                </span>
                              )}
                            </div>
                          </>
                        )}

                        {/* Add any other customer details here */}
                      </div>
                    </div>
                  ) : (
                    <div
                      key={item.ItemId}
                      // to={
                      //   isExpense
                      //    ? "/manage-receiving?expense=true"
                      //     :"/manage-receiving"
                      // }
                      // href="#"
                      // className="dropdown-item"
                      style={{ cursor: "pointer" }}
                      className={
                        cursor === index
                          ? "dropdown-item active"
                          : "dropdown-item"
                      }
                      data-name={item.ItemName?.toLowerCase()}
                    >
                      <img
                        src={item.ImageName || Noimage}
                        onError={(e) => {
                          e.currentTarget.src = Noimage;
                        }}
                        alt={item.ItemName}
                        className="img-thumbnail rounded-circle m-2"
                        width="55"
                        height="55"
                        style={{ height: "60px", objectFit: "contain" }}
                      />

                      <div className="customer-info w-100">
                        <strong className="name word-break-data">
                          {item.ItemName}{" "}
                          {item.VariationName ? `(${item.VariationName})` : ""}
                          {/* <Badge
                    className="ml-auto"
                    variant="primary"
                    style={{ position: "absolute", right: "5px" }}
                  >
                    {item.Module}
                  </Badge> */}
                        </strong>
                        {item.Module === "Accounts" ? (
                          <>
                            <div>Account Type: {item.AccountTypeName}</div>
                            <div>{item.AccountDeatilsTypeName}</div>
                          </>
                        ) : (
                          <>
                            <div>
                              {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)}{" "}
                      | Promo Price:{" "}
                      {parseFloat(item.PromoPrice).toFixed(2)}| Unit
                      Price: {parseFloat(item.UnitPrice).toFixed(2)} */}
                              {/* Cost Price: {parseFloat(item.CostPrice).toFixed(2)} | Qty: {parseInt(item.Itemquantity)} */}
                              Cost Price:{" "}
                              {parseFloat(item.CostPrice).toFixed(2)} | Qty:{" "}
                              {parseInt(item.Itemquantity)}
                            </div>
                            <div>Categories: {item.CategoryName}</div>
                            <div style={{ display: "flex", float: "right" }}>
                              {item.QuickbookId > 0 && (
                                <span>
                                  <i
                                    className="fa fa-circle"
                                    style={{ fontSize: "14px", color: "green" }}
                                  ></i>{" "}
                                  QB Sync
                                </span>
                              )}
                            </div>
                          </>
                        )}

                        {/* Add any other customer details here */}
                      </div>
                    </div>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </form>
      <RecentTransactionsModal transactionType="Expense" id={6} />
    </div>
  );
};
